import { defineStore } from 'pinia'
import axios from 'axios'
import router from '@/router/index.js' // 👈 Ajustează calea în funcție de structura ta

export const useAppStore = defineStore('app', {
  state: () => ({
    darkMode: JSON.parse(localStorage.getItem('darkMode')) || false,
    school: null,
    schoolLoading: false,
    schoolError: null,
  }),

  actions: {
    toggleDark() {
      this.darkMode = !this.darkMode
      localStorage.setItem('darkMode', JSON.stringify(this.darkMode))
    },

    async fetchSchoolDetails() {
      this.schoolLoading = true
      this.schoolError = null

      try {
        const response = await axios.get('/school/details/')
        this.school = response.data
      } catch (error) {
        console.error('❌ Eroare la încărcarea datelor școlii:', error)
        this.schoolError = 'Eroare la conectarea cu serverul.'
        
        // 🚀 Redirecționăm către pagina de eroare
        // Poți folosi `name` dacă ruta e numită, sau direct `path: '/error'`
        router.push({ name: 'ErrorPage' }) 
      } finally {
        this.schoolLoading = false
      }
    },
  },

  getters: {
    schoolName: (state) =>
      state.school?.name || 'Școala Gimnazială „Mircea cel Bătrân”',
  },
})